const rawUrl = process.env.VUE_APP_API_URL || 'http://localhost';

export const API_URL = rawUrl.endsWith('/') ? rawUrl : `${rawUrl}/`;

export default { 
    url: API_URL.replace(/\/api\/?$/i, '/'),
    apiv1: API_URL + 'v1/',
    apiv2: API_URL + 'v2/',
    API_URL: API_URL + 'v1/'
};
